import Swup from 'swup'
import SwupPreloadPlugin from '@swup/preload-plugin'
// import SwupDebugPlugin from "@swup/debug-plugin";
import SwupGtmPlugin from '@swup/gtm-plugin'
import { gsap } from 'gsap'
const lib = require('../library')

export default class Solutions {
  constructor(el) {
    this.el = el
    this.setVars()
    this.init()
  }

  setVars() {
    this.activeBar = this.el.querySelector('[data-active-marker]')
    this.links = this.el.querySelectorAll('.page-transition')
    this.activeNavCls = 's-active'
  }

  init() {
    this.handleActiveBar()
    const options = {
      plugins: [
        new SwupPreloadPlugin(),
        new SwupGtmPlugin(),
        // new SwupDebugPlugin(),
      ],
      debugMode: false,
      animateHistoryBrowsing: false,
      animationSelector: '[class*="swup-transition-"]',
      containers: ['#swup'],
      cache: true,
      linkSelector: 'a.page-transition',
      skipPopStateHandling(event) {
        if (event.state && event.state.source == 'swup') {
          return false
        }
        return true
      },
    }
    const swup = new Swup(options)
    swup.on('contentReplaced', this.reInitModules)
    // handle click @TODO: figure out what callback we could hook into in SWUP instead. Or switch to Barba.js
    this.links.forEach((element) => {
      element.addEventListener('click', this.handleClick)
    })
  }

  reInitModules() {
    lib.reInitModules('AnimationFeatureIn,RepFinder,AnimationSimpleIn,CartAddProduct,OffcanvasCart')
    // lib.reInitModules("all");
  }

  handleClick = (event) => {
    const { currentTarget } = event
    this.links.forEach((element) => {
      element.classList.remove(this.activeNavCls)
    })
    currentTarget.classList.add(this.activeNavCls)
    this.handleActiveBar()
  }

  handleActiveBar() {
    if (typeof this.activeBar === 'undefined' || this.activeBar === null) {
      return false
    }
    // find current active nav item
    const activeNav = this.el.querySelector(`.${this.activeNavCls}`)
    if (typeof activeNav === 'undefined' || activeNav === null) {
      return false
    }
    const startLeft = this.activeBar.offsetLeft
    const startWidth = this.activeBar.offsetWidth
    const moveLeftTo = activeNav.offsetLeft
    const moveWidthTo = activeNav.offsetWidth

    const tl = gsap.timeline({ duration: 0.2, ease: 'back.inOut(1)' })

    tl.fromTo(
      this.activeBar,
      {
        left: startLeft,
        width: startWidth,
      },
      {
        left: moveLeftTo,
        width: moveWidthTo,
        duration: 0.3,
      },
      '<',
    )
    // console.log(moveLeftTo);
  }
}
